class IncludeLowercaseLetter {
    validate(data) {
        return {
            isValid: /[a-z]/.test(data),
        };
    }
}
export default IncludeLowercaseLetter;
